import * as actionTypes from '../../Action/actionTypes';

export const addReception=(data)=>{
  return {
    type: actionTypes.ADD_RECEPTION,
    value: data
  }
};
